import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import styles from '../styles.module.scss';

const Titles: React.FC = () => {
    const group = useSelector((state: RootState) => state.groupReducer);
    
    // 防止幣別為 null 或不存在
    const currency = group.GroupInfo.CurrencyCode
        ? `（以 ${group.GroupInfo.CurrencyCode} 計價）`
        : '';

    return (
        <>
            <div className={styles.title}>費用說明{currency}</div>
            <div className={styles['group-name']}>{group.GroupInfo.TourName}</div>
        </>
    );
};

export default Titles;
